<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom et Postnom</span>
      </div>
      <input :value="staff.nom"
             name="staff_nom"
             disabled
             type="text"
             class="form-control">
      <input :value="staff.postnom"
             name="staff_postnom"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Prenom</span>
      </div>
      <input :value="staff.prenom"
             name="staff_prenom"
             disabled
             type="email"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nationalité</label>
      </div>
      <select name="staff_nationalite"
              disabled
              class="custom-select">
        <option>{{ staff.nationalite }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Equipe actuelle</span>
      </div>
      <input :value="(equipe_actuelle && equipe_actuelle.nom) ? equipe_actuelle.nom : ''"
             name="staff_equipe_actuelle"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipes passées</label>
      </div>
      <select name="staff_equipes_passees"
              disabled
              class="custom-select">
        <option>Choisissez un ...</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Fonction</span>
      </div>
      <select class="custom-select"
              disabled
              name="staff_fonction">
        <option :value="staff.fonction">{{ staff.fonction }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date de naissance et Age</span>
      </div>
      <input :value="staff.date_naissance"
             name="staff_date_naissance"
             disabled
             type="text"
             class="form-control">
      <input :value="staff.age"
             name="staff__age"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date début et fin du contrat</span>
      </div>
      <input :value="staff.date_debut_contrat"
             name="staff_date_debut_contrat"
             disabled
             type="text"
             class="form-control">
      <input :value="staff.date_fin_contrat"
             name="staff_date_fin_contrat"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Photo passeport</span>
      </div>
      <input :value="staff.photo_passeport"
             name="staff_photo_passeport"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Historique</span>
      </div>
      <textarea :value="staff.historique"
                name="staff_historique"
                disabled
                class="form-control">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="mr-3">Sexe : </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio" disabled
               name="staff_sexe"
               value="homme"
               :checked="(staff.sexe === 'homme') ? true : false">
        <label class="form-check-label rounded pl-2 pr-2">Homme</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio" disabled
               name="staff_sexe"
               value="femme"
               :value="(staff.sexe === 'femme') ? true : false">
        <label class="form-check-label rounded pl-2 pr-2">Femme</label>
      </div>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="staff.date_creation"
             name="staff_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="staff.temps_creation"
             name="staff_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="staff.date_modification"
             name="staff_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="staff.temps_modification"
             name="staff_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    staff: {
      type: Object
    }
  },
  data() {
    return {
      equipe_actuelle: null,
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetOneData({
      table: "equipes",
      table_id: this.staff.equipe_id
    })
        .then((data) => {
          this.equipe_actuelle = data.data
        })
        .catch((error) => {

        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > span, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > span.customized-span {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/staffs/components/Read.vue